export const textNormal = 'white'
export const textLight = '#B8BCC7'
export const taikoRed = '#E71D97'
export const blue = '#446EFF'
export const green = '#00BBA8'
export const red = '#FF5677'
export const orange = '#FBA95C'
export const buttonTextDisabled = 'rgba(255, 255, 255, 0.25)'
export const buttonDisabled = 'rgba(255, 255, 255, 0.12)'